module.exports = __webpack_public_path__ + "img/character-4.bfc922c0.png";